<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-listar #ctrl URL="factura" titulo="Facturas"></app-listar>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>

<div class="contenedor columns " style="height:100%; ">
    <div class="column is-1 is-hidden-mobile menu-izquierda">

        <!-- Menu izquierda del modulo enviroment" -->
        <app-sistema-menu-aside></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:0px;">
        <div style="background: #FFF; border-radius: 1em; ">

            <!-- Opciones y busqueda -->
            <app-tabla-opciones [ctrl]="ctrl"></app-tabla-opciones>
            <a id="catalogos" (click)="ctrl.cargarCatalogo('logos64', 'logos64', 'logo64');"></a>
            <a id="logo64" (click)="asignarLogos(ctrl.logos64); "></a>

            <div id="exportar_datos" style="overflow-y:auto; overflow-x: hidden; display:block; height: 78.4vh;" >
                <div class="notification is-black" *ngIf="borrado_exitoso">
                    ¡Se ha cancelado
                    <strong> correctamente !</strong>
                </div>

                <div class="notification is-black" *ngIf="sin_resultado != ''">
                    ¡Mesaje del servidor!
                    <strong>{{sin_resultado}}</strong>
                </div>
                <!--Tabla -->
                <table class="table is-striped  is-fullwidth" *ngIf="ctrl.tipo_grid && !ctrl.cargando">
                    <thead>
                        <tr>
                            <th>Fecha </th>
                            <th>Folio </th>
                            <th>UUID</th>
                            <th>Cliente  </th>
                            <th>Venta </th>
                            <th>Subtotal </th>
                            <th>Descuentos </th>
                            <th>Impuestos </th>
                            <th>Total </th>

                            <th class="equis">Opciones </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of ctrl.dato; let i=index" [ngClass]="{'blue-class': color[i]}">
                            <th style="vertical-align: middle;">
                                <span [ngClass]="item.estado == 3 ? 'has-text-success' : item.estado == 4 ? 'has-text-danger' : 'has-text-warning'">
                                    {{ item.fecha_expedicion | formatoFecha }}
                                </span>
                            </th>
                            <th style="vertical-align: middle;">{{ item.folio }} </th>
                            <td style="vertical-align: middle;">{{ item.uuid }} </td>
                            <td style="vertical-align: middle;">{{ item.cliente }}
                            <br>
                            <small *ngIf="item.movimientos.length > 0">
                              <span *ngIf="item.movimientos[0].personas.id!='11111111111111111111111111111111'">
                                 <strong>Alumno:</strong> <i>{{item.movimientos[0].personas.personas_metadatos.nombre_completo}}</i>
                              </span>
                              <span *ngIf="item.movimientos[0].personas.id=='11111111111111111111111111111111'">
                                <strong>Alumno:</strong> <i>No identificado</i>
                             </span>
                            </small>
                            </td>
                            <td style="vertical-align: middle;">
                                <strong class="tag" *ngFor="let val of item.movimientos;">
                                    {{val.codigo}}
                                </strong>
                            </td>

                            <td style="vertical-align: middle;">{{item.json.SubTotal | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}} </td>
                            <td style="vertical-align: middle;">{{item.json.Descuento | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}</td>
                            <td style="vertical-align: middle;">
                                <div class="columns">
                                    <div class="column is-6" *ngIf="item.json.Impuestos">
                                        <small *ngIf="item.json.Impuestos.Traslados.length > 0">Traslados</small>
                                        <div *ngFor="let traslado of item.json.Impuestos.Traslados">
                                            <strong>{{traslado.Traslado.Impuesto}} ({{traslado.Traslado.TipoFactor == 'Tasa' ? traslado.Traslado.TasaOCuota
                                                * 100 : traslado.Traslado.TasaOCuota}}%):</strong>
                                            {{traslado.Traslado.Importe | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}
                                        </div>
                                    </div>
                                    <div class="column is-6" *ngIf="item.json.Impuestos">
                                        <small *ngIf="item.json.Impuestos.Retenciones.length > 0">Retenciones</small>
                                        <div *ngFor="let retencion of item.json.Impuestos.Retenciones">
                                            <strong>{{retencion.Retencion.Impuesto}} ({{retencion.Retencion.TipoFactor == 'Tasa'
                                                ? retencion.Retencion.TasaOCuota * 100 : retencion.Retencion.TasaOCuota}}%):</strong>
                                            {{retencion.Retencion.Importe | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td style="vertical-align: middle;">{{item.json.Total | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}} </td>


                            <td style="vertical-align: middle;" class="has-text-centered no_pdf">

                                <nav class="level is-mobile" >
                                    <div class="level-left" *ngIf="item.estado == 3">

                                        <!-- acciones -->
                                        <a [ngClass]="{'is-loading': pdf_cargando && contador == index}" *ngIf="permisos.indexOf('FacturaController.show') > -1 "
                                            class="navbar-item  button" (click)="asignarLogos(ctrl.logos64); pdf(item);">
                                            <span class="icon fa-2x has-text-link">
                                                <i class="fa fa-file-pdf-o"></i>
                                            </span>
                                        </a>

                                        <a [ngClass]="{'is-loading': xml_cargando && contador == index}" *ngIf="permisos.indexOf('FacturaController.show') > -1 "
                                            class="navbar-item  button" (click)="xml(item, index)">
                                            <span class="icon fa-2x has-text-info">
                                                <i class="fa fa-file-excel-o"></i>
                                            </span>
                                        </a>

                                        <a [ngClass]="{'is-loading': cancelar_cargando && contador == index}" *ngIf="permisos.indexOf('FacturaController.destroy') > -1 && item.estado == '3' "
                                            class="navbar-item  button" (click)="ventana_cancelar(item, item.uuid, i)">
                                            <span class="icon fa-2x has-text-danger">
                                                <i class="icon-trash"></i>
                                            </span>
                                        </a>

                                        <a [ngClass]="{'is-loading': cargando && contador == index}" *ngIf="permisos.indexOf('FacturaController.enviar') > -1 "
                                            class="navbar-item  button" (click)="enviar(item, index)">
                                            <span class="icon fa-2x has-text-success">
                                                <i class="icon-email2"></i>
                                            </span>
                                        </a>
                                    </div>

                                    <div class="level-left" *ngIf="item.estado == 1 || item.estado == 2">
                                      Pendiente
                                    </div>

                                    <div class="level-left" *ngIf="item.estado == 4">
                                      Cancelado

                                      <a [ngClass]="{'is-loading': xml_cargando && contador == index}" *ngIf="permisos.indexOf('FacturaController.show') > -1 "
                                        class="navbar-item  button" (click)="xml(item, index)">
                                        <span class="icon fa-2x has-text-info">
                                          <i class="fa fa-file-excel-o"></i>
                                        </span>
                                      </a>
                                    </div>
                                </nav>
                            </td>

                        </tr>
                        <tr *ngIf="ctrl.dato.length == 0">
                            <td colspan="12" style="vertical-align: middle; color:#888;">Esta lista está vacía.</td>
                        </tr>
                    </tbody>

                </table>

                <!--Lista -->
                <span *ngIf="!ctrl.tipo_grid && !ctrl.cargando" class="lista_lista">
                    <div class="box" *ngFor="let item of ctrl.dato; let i=index" style="margin-bottom:0.1rem;" [style.background]="i%2 == 0 ? '#fafafa' : '#ffffff'">
                        <article class="media">
                            <div class="media-left">
                                <figure class="image is-64x64">
                                    <img [src]="'data:image/png;base64,' + item.json?.Complemento.TimbreFiscalDigital.qr" *ngIf="item.json?.Complemento.TimbreFiscalDigital.qr != ''">
                                </figure>
                            </div>
                            <div class="media-content" [ngClass]="{'blue-class': color[i]}">
                                <div class="content">
                                    <strong class="tag is-medium" [ngClass]="item.estado == 3 ? 'is-success' : item.estado == 4 ? 'is-danger' : 'is-warning'">
                                        Fecha: {{ item.fecha_expedicion | formatoFecha }}
                                    </strong>
                                    <strong class="tag is-dark is-medium">
                                        UUID: {{item.uuid}}
                                    </strong>
                                    <span class="tag is-link is-medium">Cliente: {{item.cliente}}</span>

                                    <span class="tag is-light is-small">Subtotal : {{item.json.SubTotal | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}
                                    </span>
                                    <span class="tag is-light is-small">Descuento : {{ item.json.Descuento | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}</span>
                                    <span class="tag is-light is-small">Impuestos :
                                        <div class="columns">
                                            <div class="column is-6" *ngIf="item.json.Impuestos">
                                                <small *ngIf="item.json.Impuestos.Traslados.length > 0">Traslados</small>
                                                <div *ngFor="let traslado of item.json.Impuestos.Traslados">
                                                    <strong>{{traslado.Traslado.Impuesto}} ({{traslado.Traslado.TipoFactor == 'Tasa'
                                                        ? traslado.Traslado.TasaOCuota * 100 : traslado.Traslado.TasaOCuota}}%):</strong>
                                                    {{traslado.Traslado.Importe | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}
                                                </div>
                                            </div>
                                            <div class="column is-6" *ngIf="item.json.Impuestos">
                                                <small *ngIf="item.json.Impuestos.Retenciones.length > 0">Retenciones</small>
                                                <div *ngFor="let retencion of item.json.Impuestos.Retenciones">
                                                    <strong>{{retencion.Retencion.Impuesto}} ({{retencion.Retencion.TipoFactor ==
                                                        'Tasa' ? retencion.Retencion.TasaOCuota * 100 : retencion.Retencion.TasaOCuota}}%):</strong>
                                                    {{retencion.Retencion.Importe | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}
                                                </div>
                                            </div>
                                        </div>
                                    </span>
                                    <span class="tag is-light is-small">Total : {{ item.json.Total | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}</span>
                                    <p>
                                        <strong class="tag" *ngFor="let val of item.movimientos;">
                                            Venta: {{val.codigo}}
                                        </strong>



                                        <span class="tag is-link" *ngIf="item.usuario">Usuario: {{ item.usuario.nombre }}</span>
                                    </p>
                                </div>
                                <nav class="level is-mobile" style="float:right" *ngIf="item.estado == 3">
                                    <div class="level-left">

                                        <!-- acciones -->
                                        <a [ngClass]="{'is-loading': pdf_cargando && contador == index}" *ngIf="permisos.indexOf('FacturaController.show') > -1 "
                                            class="navbar-item  button" (click)="asignarLogos(ctrl.logos64); pdf(item);">
                                            <span class="icon fa-2x has-text-link">
                                                <i class="fa fa-file-pdf-o"></i>
                                            </span>
                                        </a>

                                        <a [ngClass]="{'is-loading': xml_cargando && contador == index}" *ngIf="permisos.indexOf('FacturaController.show') > -1 "
                                            class="navbar-item  button" (click)="xml(item, index)">
                                            <span class="icon fa-2x has-text-info">
                                                <i class="fa fa-file-excel-o"></i>
                                            </span>
                                        </a>

                                        <a [ngClass]="{'is-loading': cancelar_cargando && contador == index}" *ngIf="permisos.indexOf('FacturaController.destroy') > -1 && item.estado == '3' "
                                            class="navbar-item  button" (click)="ventana_cancelar(item, item.uuid, i)">
                                            <span class="icon fa-2x has-text-danger">
                                                <i class="icon-trash"></i>
                                            </span>
                                        </a>

                                        <a [ngClass]="{'is-loading': cargando && contador == index}" *ngIf="permisos.indexOf('FacturaController.enviar') > -1 "
                                            class="navbar-item  button" (click)="enviar(item, index)">
                                            <span class="icon fa-2x has-text-success">
                                                <i class="icon-email2"></i>
                                            </span>
                                        </a>
                                    </div>
                                </nav>
                                <span *ngIf="item.estado == 1 || item.estado == 2">Pendiente</span>
                                <span *ngIf="item.estado == 4" class="has-text-danger">Cancelado</span>
                            </div>
                        </article>
                    </div>
                </span>
              </div>
            <!-- Paginación para la lista  -->
            <app-paginacion [ctrl]="ctrl"></app-paginacion>
        </div>

    </div>
</div>

<div class="modal" id="confirmarCancelar">
    <div class="modal-background"></div>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">
                <i class="fa fa-warning"></i> Confirmar
            </p>
            <button class="delete" (click)="ctrl.cancelarModal('confirmarCancelar')"></button>
        </header>
        <section class="modal-card-body">
            <div class="notification is-danger" *ngIf="error_cancelar">
                ¡Ocurrio un error al intentar cancelar la factura!
                <strong>Por favor</strong>, intentelo de nuevo
            </div>

            <div class="notification is-black" *ngIf="sin_resultado != ''">
                ¡Mesaje del servidor!
                <strong>{{sin_resultado}}</strong>
            </div>
            <div *ngIf="errores.length > 0">
                <div class="notification is-danger" *ngFor="let msg of errores;">
                    <font size="6pt">{{msg.codigo}}</font> {{msg.mensaje}}
                    <strong>{{msg.fecha | formatoFecha}}</strong>
                </div>
            </div>
            <div class="is-fullwidth has-text-centered" *ngIf="cargando">
                <br>
                <span class="tag is-primary is-large ">
                    <span class="icon">
                        <i class="icon-worldwide fa-spin"></i>
                    </span> &nbsp;
                    <span>Cargando...</span>
                </span>
                <br>
                <br>
            </div>
            <div class="content">
                <h1>¿Esta seguro de iniciar el proceso de cancelación?</h1>
                <p>Ya no se podra modificar una vez realizado la petición</p>
            </div>
        </section>
        <footer class="modal-card-foot">
            <a class="button is-success" (click)="cancelar(factura_json, factura_uuid, factura_index)" [ngClass]="{'is-loading': borrarCargando}">Continuar</a>
            <a class="button" (click)="ctrl.cancelarModal('confirmarCancelar')">Cancelar</a>
        </footer>
    </div>
</div>

<div class="modal" id="verPdf">
    <div class="modal-background"></div>
    <div class="modal-card" style="width:80%" *ngIf="facturacion">
        <header class="modal-card-head">
            <div class="modal-card-title">
                <nav class="level">
                    <!-- Left side -->
                    <div class="level-left">
                        <div class="level-item">
                            <p class="subtitle is-5">
                                <strong>PDF </strong>
                            </p>
                        </div>
                    </div>

                    <!-- Right side -->
                    <div class="level-right">
                        <p class="level-item">
                            <a class="navbar-item " id="imprimir_pdf" (click)="ctrl.imprimeFactura(facturacion, logo, personas_rfcs_seleccionado)">
                                <span class="icon fa-2x">
                                    <i class="icon-printer2"></i>
                                </span>
                                <span class="text">Imprimir</span>
                            </a>
                        </p>
                    </div>
                </nav>
            </div>
            <button class="delete" (click)="ctrl.cancelarModal('verPdf')"></button>
        </header>
        <section class="modal-card-body" *ngIf="facturacion?.Complemento">

            <div class="box" id="imprimir">
                <article class="media">
                    <div class="media-content">
                        <div>
                            <!-- emisor -->
                            <div class="columns">
                                <div class="column is-2">
                                    <figure class="image is-1by1 figure-border logo">
                                        <img [src]="ctrl.configuracion.empresa.logo ? ctrl.API_PATH+'/adjunto/configuracion/'+ ctrl.configuracion.empresa.logo : './assets/yoursoft.png'">
                                    </figure>
                                </div>

                                <div class="column is-6">
                                    <div class="box">
                                        <article class="media">
                                            <div class="media-content">
                                                <div class="content">
                                                    <p>
                                                        <strong>Folio fiscal: </strong>
                                                        {{facturacion.Complemento.TimbreFiscalDigital.UUID}}
                                                    </p>
                                                    <p>
                                                        <strong>No. de serie del CSD: </strong>
                                                        {{facturacion.NoCertificado}}
                                                    </p>
                                                    <p>
                                                        <strong>No. de serie del certificado SAT: </strong>
                                                        {{facturacion.Complemento.TimbreFiscalDigital.NoCertificadoSAT}}
                                                    </p>
                                                    <p>
                                                        <strong>Fecha y hora de emisión: </strong>
                                                        {{facturacion.Fecha }}
                                                    </p>
                                                    <p>
                                                        <strong>Fecha y hora de certificación: </strong>
                                                        {{facturacion.Complemento.TimbreFiscalDigital.FechaTimbrado}}
                                                    </p>
                                                </div>
                                            </div>
                                        </article>
                                    </div>
                                </div>

                                <div class="column is-4">
                                    <div class="box">
                                        <article class="media">
                                            <div class="media-content">
                                                <div class="content">
                                                    <p>
                                                        <strong>Emisor: </strong>
                                                        {{facturacion.Emisor.Nombre}}
                                                    </p>
                                                    <p>
                                                        <strong>R.F.C.: </strong>
                                                        {{facturacion.Emisor.Rfc}}
                                                    </p>
                                                    <p>
                                                        <strong>Lugar de expedición: </strong>
                                                        {{facturacion.LugarExpedicion}}
                                                    </p>
                                                    <p>
                                                        <strong>Régimen fiscal: </strong>
                                                        {{facturacion.Emisor.RegimenFiscal}}
                                                    </p>
                                                    <p>
                                                        <strong>Tipo de comprobante: </strong>
                                                        {{facturacion.TipoDeComprobante}}
                                                    </p>

                                                </div>
                                            </div>
                                        </article>
                                    </div>
                                </div>
                            </div>
                            <!-- datos del cliente -->
                            <div class="columns">
                                <div class="column is-8">
                                    <div class="box">
                                        <article class="media">
                                            <div class="media-content">
                                                <div class="content">
                                                    <p>
                                                        <strong>Receptor:</strong>
                                                        {{facturacion.Receptor.Nombre}}
                                                    </p>
                                                    <p>
                                                        <strong>R.F.C.:</strong>
                                                        {{facturacion.Receptor.Rfc}}
                                                    </p>
                                                </div>
                                            </div>
                                        </article>
                                    </div>
                                </div>
                                <div class="column is-4">
                                    <div class="box">
                                        <article class="media">
                                            <div class="media-content">
                                                <div class="content">
                                                    <p>
                                                        <strong>Uso CFDI:</strong>
                                                        {{facturacion.Receptor.UsoCFDI}}
                                                    </p>
                                                    <p>
                                                        <strong>Folio y serie:</strong>
                                                        {{facturacion.Folio}} {{facturacion.Serie}}
                                                    </p>
                                                </div>
                                            </div>
                                        </article>
                                    </div>
                                </div>
                            </div>

                            <!-- complemento educativo -->
                            <div class="columns" *ngIf="facturacion.Conceptos.Concepto.length > 0 && facturacion.Conceptos.Concepto[0].ComplementoConcepto && facturacion.Conceptos.Concepto[0].ComplementoConcepto.nivelEducativo">
                              <div class="column is-12">
                                <div class="box">
                                  <article class="media">
                                    <div class="media-content">
                                      <div class="content">
                                        <table class="table is-striped  is-fullwidth">
                                          <thead>
                                            <tr>
                                              <th>IEDU Versión</th>
                                              <th>Alumno </th>
                                              <th>CURP </th>
                                              <th>Nivel</th>
                                              <th>RVOE </th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <tr>
                                              <td>{{facturacion.Conceptos.Concepto[0].ComplementoConcepto.version}}</td>
                                              <td>{{facturacion.Conceptos.Concepto[0].ComplementoConcepto.nombreAlumno}}</td>
                                              <td>{{facturacion.Conceptos.Concepto[0].ComplementoConcepto.CURP}}</td>
                                              <td>{{facturacion.Conceptos.Concepto[0].ComplementoConcepto.nivelEducativo}}</td>
                                              <td>{{facturacion.Conceptos.Concepto[0].ComplementoConcepto.autRVOE}}</td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </article>
                                </div>
                              </div>
                            </div>

                            <!-- detalle de los articulos -->
                            <div class="columns">
                                <div class="column is-12">
                                    <div class="box">
                                        <article class="media">
                                            <div class="media-content">
                                                <div class="content">
                                                    <table class="table is-striped  is-fullwidth">
                                                        <thead>
                                                            <tr>
                                                                <th>Cve prod/serv </th>
                                                                <th>No. Identificacion </th>
                                                                <th>Cantidad </th>
                                                                <th>Unidad</th>
                                                                <th>Descripción </th>
                                                                <th>Precio </th>
                                                                <th>Descuento </th>
                                                                <th>Impuesto </th>
                                                                <th>Importe </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr *ngFor="let concepto of facturacion.Conceptos.Concepto">
                                                                <td>{{concepto.ClaveProdServ}}</td>
                                                                <td>{{concepto.NoIdentificacion}}</td>
                                                                <td>{{concepto.Cantidad}}</td>
                                                                <td>{{concepto.ClaveUnidad}} {{concepto.Unidad}}</td>
                                                                <td>{{concepto.Descripcion}}</td>
                                                                <td>{{concepto.ValorUnitario | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}</td>
                                                                <td>{{concepto.Descuento | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}</td>
                                                                <td *ngIf="!concepto.Impuestos"></td>
                                                                <td *ngIf="concepto.Impuestos">
                                                                    <small *ngIf="concepto.Impuestos.Traslados">Traslados</small>
                                                                    <span *ngFor="let traslado of concepto.Impuestos.Traslados">
                                                                        <strong>{{traslado.Traslado.Impuesto}} ({{traslado.Traslado.TipoFactor
                                                                            == 'Tasa' ? traslado.Traslado.TasaOCuota * 100
                                                                            : traslado.Traslado.TasaOCuota}}%):</strong>
                                                                        {{traslado.Traslado.Importe | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}
                                                                    </span>

                                                                    <small *ngIf="concepto.Impuestos.Retenciones">Retenciones</small>
                                                                    <span *ngFor="let retencion of concepto.Impuestos.Retenciones">
                                                                        <strong>{{retencion.Retencion.Impuesto}} ({{retencion.Retencion.TipoFactor
                                                                            == 'Tasa' ? retencion.Retencion.TasaOCuota *
                                                                            100 : retencion.Retencion.TasaOCuota}}%):</strong>
                                                                        {{retencion.Retencion.Importe | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}
                                                                    </span>
                                                                </td>
                                                                <td>{{concepto.Importe | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}</td>
                                                            </tr>
                                                        </tbody>

                                                    </table>
                                                </div>
                                            </div>
                                        </article>
                                    </div>
                                </div>
                            </div>
                            <!-- pago -->
                            <div class="columns">
                                <div class="column is-8">
                                    <div class="box">
                                        <article class="media">
                                            <div class="media-content">
                                                <div class="content">
                                                    <div>
                                                        <strong>Total con letra</strong>
                                                        {{facturacion.Total | numeroLetra:configuracion.sucursal.moneda}}
                                                        <hr class="hr">
                                                    </div>
                                                    <div class="columns">
                                                        <div class="column is-6">
                                                            <p>
                                                                <strong>Moneda:</strong>
                                                                {{facturacion.Moneda}}
                                                            </p>
                                                            <p>
                                                                <strong>Forma de pago:</strong>
                                                                {{facturacion.FormaPago}}
                                                            </p>
                                                        </div>
                                                        <div class="column is-6">
                                                            <p>
                                                                <strong>Método de pago:</strong>
                                                                {{facturacion.MetodoPago}}
                                                            </p>
                                                            <p>
                                                                <strong>Condiciones de pago:</strong>
                                                                <span class="sellos_sat" style="word-wrap: break-word; font-size:9pt;">
                                                                    {{facturacion.CondicionesDePago}}
                                                                </span>
                                                            </p>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </article>
                                    </div>
                                </div>
                                <div class="column is-4">
                                    <div class="box">
                                        <article class="media">
                                            <div class="media-content">
                                                <div class="content">
                                                    <p>
                                                        <strong>Subtotal:</strong>
                                                        {{facturacion.SubTotal | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}
                                                    </p>
                                                    <p>
                                                        <strong>Descuento:</strong>
                                                        {{facturacion.Descuento | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}
                                                    </p>
                                                    <div class="impuestos_fac" *ngIf="facturacion.Impuestos">

                                                        <small *ngIf="facturacion.Impuestos.Traslados">Traslados</small>
                                                        <p *ngFor="let traslado of facturacion.Impuestos.Traslados">
                                                            <strong>{{traslado.Traslado.Impuesto}} ({{traslado.Traslado.TipoFactor
                                                                == 'Tasa' ? traslado.Traslado.TasaOCuota * 100 : traslado.Traslado.TasaOCuota}}%):</strong>
                                                                {{traslado.Traslado.Importe | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}

                                                        </p>
                                                    </div>
                                                    <div class="impuestos_fac" *ngIf="facturacion.Impuestos">
                                                        <small *ngIf="facturacion.Impuestos.Retenciones">Retenciones</small>
                                                        <p *ngFor="let retencion of facturacion.Impuestos.Retenciones">
                                                            <strong>{{retencion.Retencion.Impuesto}} ({{retencion.Retencion.TipoFactor
                                                                == 'Tasa' ? retencion.Retencion.TasaOCuota * 100 : retencion.Retencion.TasaOCuota}}%):</strong>
                                                                {{retencion.Retencion.Importe | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}

                                                        </p>
                                                    </div>
                                                    <p>
                                                        <strong>Total:
                                                        {{facturacion.Total | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}</strong>
                                                    </p>
                                                </div>
                                            </div>
                                        </article>
                                    </div>
                                </div>
                            </div>

                            <!-- qy y sellos -->
                            <div class="columns">
                                <div class="column is-2">
                                    <figure class="image is-1by1 figure-border">
                                        <img [src]="'data:image/png;base64,' + facturacion.Complemento.TimbreFiscalDigital.qr" *ngIf="facturacion.Complemento.TimbreFiscalDigital.qr != ''">
                                        <img src="assets/qr.png" *ngIf="facturacion.Complemento.TimbreFiscalDigital.qr == ''">
                                    </figure>
                                </div>
                                <div class="column is-10">
                                    <div class="box">
                                        <article class="media">
                                            <div class="media-content">
                                                <div class="content sellos">
                                                    <div>
                                                        <strong>Sello digital del CFDI:</strong>
                                                        <br>
                                                        <div class="sellos_sat" style="word-wrap: break-word; font-size:8.5pt;">
                                                            {{facturacion.Complemento.TimbreFiscalDigital.SelloCFD}}
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <strong>Sello digital del SAT:</strong>
                                                        <br>
                                                        <div class="sellos_sat" style="word-wrap: break-word; font-size:8.5pt;">
                                                            {{facturacion.Complemento.TimbreFiscalDigital.SelloSAT}}
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <strong>Cadena original del complemento de certificación del SAT:
                                                        </strong>
                                                        <br>
                                                        <div class="sellos_sat" style="word-wrap: break-word; font-size:8.5pt;">
                                                            {{facturacion.Complemento.TimbreFiscalDigital.CadenaOriginal}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </article>
                                    </div>
                                </div>
                            </div>
                            <p align="center">
                                <strong>Este documento es una representación impresa de un CFDI versión {{VERSION_CFDI}}</strong>
                            </p>
                        </div>
                    </div>
                </article>
            </div>
        </section>
        <footer class="modal-card-foot">
            <a class="button" (click)="ctrl.cancelarModal('verPdf')">Cancelar</a>
        </footer>
    </div>
</div>


<div id="enviar_pdf" style="display:none" *ngIf="facturacion?.Complemento">
    <table class="table is-fullwidth">
        <tbody>
            <tr>
                <th>
                    <table class="table is-fullwidth">
                        <tr>
                            <td class="column is-2">
                                <div class="logo">
                                    <img [src]="ctrl.configuracion.empresa.logo ? ctrl.API_PATH+'/adjunto/configuracion/'+ ctrl.configuracion.empresa.logo : './assets/yoursoft.png'">
                                </div>
                            </td>
                            <td class="column is-6">
                                <div class="box">
                                    <article class="media">
                                        <div class="media-content">
                                            <div class="content">
                                                <p>
                                                    <strong>Folio fiscal: </strong>
                                                    {{facturacion.Complemento.TimbreFiscalDigital.UUID}}
                                                </p>
                                                <p>
                                                    <strong>No. de serie del CSD: </strong>
                                                    {{facturacion.NoCertificado}}
                                                </p>
                                                <p>
                                                    <strong>No. de serie del certificado SAT: </strong>
                                                    {{facturacion.Complemento.TimbreFiscalDigital.NoCertificadoSAT}}
                                                </p>
                                                <p>
                                                    <strong>Fecha y hora de emisión: </strong>
                                                    {{facturacion.Fecha }}
                                                </p>
                                                <p>
                                                    <strong>Fecha y hora de certificación: </strong>
                                                    {{facturacion.Complemento.TimbreFiscalDigital.FechaTimbrado}}
                                                </p>
                                            </div>
                                        </div>
                                    </article>
                                </div>
                            </td>
                            <td class="column is-4">
                                <div class="box">
                                    <article class="media">
                                        <div class="media-content">
                                            <div class="content">
                                                <p>
                                                    <strong>Emisor: </strong>
                                                    {{facturacion.Emisor.Nombre}}
                                                </p>
                                                <p>
                                                    <strong>R.F.C.: </strong>
                                                    {{facturacion.Emisor.Rfc}}
                                                </p>
                                                <p>
                                                    <strong>Lugar de expedición: </strong>
                                                    {{facturacion.LugarExpedicion}}
                                                </p>
                                                <p>
                                                    <strong>Régimen fiscal: </strong>
                                                    {{facturacion.Emisor.RegimenFiscal}}
                                                </p>
                                                <p>
                                                    <strong>Tipo de comprobante: </strong>
                                                    {{facturacion.TipoDeComprobante}}
                                                </p>

                                            </div>
                                        </div>
                                    </article>
                                </div>
                            </td>
                        </tr>
                    </table>
                </th>
            </tr>
            <tr>
                <th>
                    <table class="table is-fullwidth">
                        <tr>
                            <td class="column is-8">
                                <div class="box">
                                    <article class="media">
                                        <div class="media-content">
                                            <div class="content">
                                                <p>
                                                    <strong>Receptor:</strong>
                                                    {{facturacion.Receptor.Nombre}}
                                                </p>
                                                <p>
                                                    <strong>R.F.C.:</strong>
                                                    {{facturacion.Receptor.Rfc}}
                                                </p>
                                            </div>
                                        </div>
                                    </article>
                                </div>
                            </td>
                            <td class="column is-4">
                                <div class="box">
                                    <article class="media">
                                        <div class="media-content">
                                            <div class="content">
                                                <p>
                                                    <strong>Uso CFDI:</strong>
                                                    {{facturacion.Receptor.UsoCFDI}}
                                                </p>
                                                <p>
                                                    <strong>Folio y serie:</strong>
                                                    {{facturacion.Folio}} {{facturacion.Serie}}
                                                </p>
                                            </div>
                                        </div>
                                    </article>
                                </div>
                            </td>
                        </tr>
                    </table>
                </th>
            </tr>
            <tr>
                <th>
                    <div class="box">
                        <article class="media">
                            <div class="media-content">
                                <div class="content">
                                    <table class="table is-striped  is-fullwidth">
                                        <thead>
                                            <tr>
                                                <th>Cve prod/serv </th>
                                                <th>No. Identificacion </th>
                                                <th>Cantidad </th>
                                                <th>Unidad</th>
                                                <th>Descripción </th>
                                                <th>Precio </th>
                                                <th>Descuento </th>
                                                <th>Impuesto </th>
                                                <th>Importe </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let concepto of facturacion.Conceptos.Concepto">
                                                <td>{{concepto.ClaveProdServ}}</td>
                                                <td>{{concepto.NoIdentificacion}}</td>
                                                <td>{{concepto.Cantidad}}</td>
                                                <td>{{concepto.ClaveUnidad}} {{concepto.Unidad}}</td>
                                                <td>{{concepto.Descripcion}}</td>
                                                <td>{{concepto.ValorUnitario | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}</td>
                                                <td>{{concepto.Descuento | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}</td>
                                                <td>
                                                    <small *ngIf="concepto.Impuestos.Traslados">Traslados</small>
                                                    <span *ngFor="let traslado of concepto.Impuestos.Traslados">
                                                        <strong>{{traslado.Traslado.Impuesto}} ({{traslado.Traslado.TipoFactor == 'Tasa' ? traslado.Traslado.TasaOCuota
                                                            * 100 : traslado.Traslado.TasaOCuota}}%):</strong>
                                                        {{traslado.Traslado.Importe | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}
                                                    </span>

                                                    <small *ngIf="concepto.Impuestos.Retenciones">Retenciones</small>
                                                    <span *ngFor="let retencion of concepto.Impuestos.Retenciones">
                                                        <strong>{{retencion.Retencion.Impuesto}} ({{retencion.Retencion.TipoFactor == 'Tasa' ? retencion.Retencion.TasaOCuota
                                                            * 100 : retencion.Retencion.TasaOCuota}}%):</strong>
                                                        {{retencion.Retencion.Importe | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}
                                                    </span>
                                                </td>
                                                <td>{{concepto.Importe | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}</td>
                                            </tr>
                                        </tbody>

                                    </table>
                                </div>
                            </div>
                        </article>
                    </div>
                </th>
            </tr>
            <tr>
                <th>
                    <table class="table is-fullwidth">
                        <tr>
                            <td class="column is-8">
                                <div class="box">
                                    <article class="media">
                                        <div class="media-content">
                                            <div class="content">
                                                <div>
                                                    <strong>Total con letra</strong>
                                                    {{facturacion.Total | numeroLetra:configuracion.sucursal.moneda}}
                                                    <hr class="hr">
                                                </div>
                                                <table class="table is-fullwidth">
                                                    <tr>
                                                        <td class="column is-6">
                                                            <p>
                                                                <strong>Moneda:</strong> {{facturacion.Moneda}} </p>

                                                            <strong>Forma de pago:</strong> {{facturacion.MetodoPago}}
                                                        </td>
                                                        <td class="column is-6">
                                                            <p>
                                                                <strong>Método de pago:</strong> {{facturacion.FormaPago}} </p>

                                                            <strong>Condiciones de pago:</strong>
                                                            <span>
                                                                 {{facturacion.CondicionesDePago}}
                                                            </span>

                                                        </td>

                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                    </article>
                                </div>
                            </td>
                            <td class="column is-4">
                                <div class="box">
                                    <article class="media">
                                        <div class="media-content">
                                            <div class="content">
                                                <p>
                                                    <strong>Subtotal:</strong>
                                                    {{facturacion.SubTotal | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}
                                                </p>
                                                <p>
                                                    <strong>Descuento:</strong>
                                                    {{facturacion.Descuento | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}
                                                </p>
                                                <div class="impuestos_fac" *ngIf="facturacion.Impuestos">

                                                    <small *ngIf="facturacion.Impuestos.Traslados">Traslados</small>
                                                    <p *ngFor="let traslado of facturacion.Impuestos.Traslados">
                                                        <strong>{{traslado.Traslado.Impuesto}} ({{traslado.Traslado.TipoFactor == 'Tasa' ? traslado.Traslado.TasaOCuota * 100
                                                            : traslado.Traslado.TasaOCuota}}%):</strong>
                                                        {{traslado.Traslado.Importe | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}

                                                    </p>
                                                </div>
                                                <div class="impuestos_fac" *ngIf="facturacion.Impuestos">
                                                    <small *ngIf="facturacion.Impuestos.Retenciones">Retenciones</small>
                                                    <p *ngFor="let retencion of facturacion.Impuestos.Retenciones">
                                                        <strong>{{retencion.Retencion.Impuesto}} ({{retencion.Retencion.TipoFactor == 'Tasa' ? retencion.Retencion.TasaOCuota
                                                            * 100 : retencion.Retencion.TasaOCuota}}%):</strong>
                                                        {{retencion.Retencion.Importe | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}

                                                    </p>
                                                </div>
                                                <p>
                                                    <strong>Total: {{facturacion.Total | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}</strong>
                                                </p>
                                            </div>
                                        </div>
                                    </article>
                                </div>
                            </td>
                        </tr>
                    </table>
                </th>
            </tr>
            <tr>
                <th>
                    <table class="table is-fullwidth">
                        <tr>
                            <td class="column is-2">
                                <div class="logo">
                                    <img [src]="'data:image/png;base64,' + facturacion.Complemento.TimbreFiscalDigital.qr" >
                                </div>
                            </td>
                            <td class="column is-10" >
                                <div class="box">
                                    <article class="media">
                                        <div class="media-content">
                                            <div class="content sellos">
                                                <div>
                                                    <strong>Sello digital del CFDI:</strong>
                                                    <br>
                                                    <div class="sellos_sat" style="word-wrap: break-word; font-size:8.5pt;">
                                                        {{SelloCFD[0]}}
                                                        <br>
                                                         {{SelloCFD[1]}}
                                                    </div>
                                                </div>
                                                <div>
                                                    <strong>Sello digital del SAT:</strong>
                                                    <br>
                                                    <div class="sellos_sat" style="word-wrap: break-word; font-size:8.5pt;">

                                                         {{SelloSAT[0]}}
                                                        <br> {{SelloSAT[1]}}
                                                    </div>
                                                </div>
                                                <div>
                                                    <strong>Cadena original del complemento de certificación del SAT:
                                                    </strong>
                                                    <br>
                                                    <div class="sellos_sat" style="word-wrap: break-word; font-size:8.5pt;">

                                                         {{CadenaOriginal[0]}}
                                                        <br> {{CadenaOriginal[1]}}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </article>
                                </div>
                            </td>
                        </tr>
                    </table>
                </th>
            </tr>
        </tbody>
    </table>
</div>
